import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useStorage } from '@vueuse/core'
import { useApi } from '/@src/composable/useApi'

export type UserData = Record<string, any> | null | any

export const useUserSession = defineStore('userSession', () => {
  // token will be synced with local storage
  // @see https://vueuse.org/core/usestorage/
  const token = useStorage('token', '')

  const user = ref<Partial<UserData> | any>()
  const loading = ref(true)
  const isApk = useStorage('apk', false)
  const isIframe = useStorage('is_iframe', false)
  // const isApk = ref(false)

  const isLoggedIn = computed(() => token.value !== undefined && token.value !== '' && token.value !== 'undefined' && token.value !== 'null')

  function setUser(newUser: Partial<UserData>) {
    user.value = newUser
  }

  function setToken(newToken: string) {
    token.value = newToken
  }

  function setLoading(newLoading: boolean) {
    loading.value = newLoading
  }

  function setApk(newApk: boolean) {
    isApk.value = newApk
  }

  function setIsIframe(newIsIframe: boolean) {
    isIframe.value = newIsIframe
  }

  async function logoutUser() {
    const api = useApi()
    try {
      await api.post('/v1/auth/logout', {}, {
        headers: {
          Authorization: `Bearer ${token.value}`
        },
        validateStatus: () => true
      })
    } catch (error) {
      console.warn('Logout request failed, clearing local session anyway')
    } finally {
      token.value = undefined
      user.value = undefined
    }
  }

  return {
    user,
    token,
    isIframe,
    isLoggedIn,
    loading,
    isApk,
    logoutUser,
    setUser,
    setToken,
    setLoading,
    setApk,
    setIsIframe,
  } as const
})

/**
 * Pinia supports Hot Module replacement so you can edit your stores and
 * interact with them directly in your app without reloading the page.
 *
 * @see https://pinia.esm.dev/cookbook/hot-module-replacement.html
 * @see https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserSession, import.meta.hot))
}
